import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './Footer.css';

function Footer() {
  const [legalContent, setLegalContent] = useState('');

  useEffect(() => {
    // Fetch the Markdown file
    fetch('/Totly%20legal.md')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load legal content');
        }
        return response.text();
      })
      .then(text => setLegalContent(text))
      .catch(error => {
        console.error('Error loading legal content:', error);
        setLegalContent('Unable to load terms and conditions.');
      });
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About Us</h4>
          <p>Your platform for buying, selling, and connecting with the Totly community</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/buysell">Buy & Sell</a></li>
            <li><a href="/forums">Forums</a></li>
            <li><a href="/messages">Messages</a></li>
            <li><button type="button" className="link-button" onClick={(e) => {e.preventDefault(); document.getElementById('terms-modal').style.display = 'block';}}>Terms & Conditions</button></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact</h4>
          <p>Email: support@totly.co.za</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Totly. All rights reserved.</p>
      </div>
      
      {/* Terms and Conditions Modal */}
      <div id="terms-modal" className="modal">
        <div className="modal-content">
          <span className="close" onClick={() => document.getElementById('terms-modal').style.display = 'none'}>&times;</span>
          <h2>Terms and Conditions</h2>
          <div className="terms-content">
            <div className="markdown-content">
              <ReactMarkdown>{legalContent}</ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 